import {
    GET_SCHOOLS_DROPDOWN,
    SCHOOLS_LOADING,
} from './types';

const initialState = {
    schoolsDropdown: [],
    schoolsLoading: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SCHOOLS_LOADING:
            return {
                ...state,
                schoolsLoading: true
            };
        case GET_SCHOOLS_DROPDOWN:
            return {
                ...state,
                schoolsDropdown: action.payload.posts,
                schoolsLoading: false
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/features/Schools/reducers.js